// extracted by mini-css-extract-plugin
export default {"container":"_e876779d"};